//Интерфейс для работы с корзиной

//обновления блока с информацией о корзине
var updateCartBlock = function () {
    var totalSum = 0,
        totalCount = 0,
        $cart = $(".js-cart");

    for (var i = 0; i < Cart.items.length; i++) {
        totalSum += Cart.items[i].price * Cart.items[i].qty;
        totalCount += parseInt(Cart.items[i].qty, 10);
    }

    if (totalCount > 0) {
        $cart.show();
        $cart
            .find(".js-cart_total_count_txt")
            .text(totalCount);

        $cart
            .find(".js-cart_total_price")
            .text(Meta.beautyPrice(totalSum) + ' ₽');
        // уберем пока анимацию
        // .addClass('pulse animated')
        // .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
        //     $(this).removeClass('pulse animated');
        // });

        // $cart
        //     .find(".js-cart_title_end")
        //     .text(Meta.decline(totalCount, "", "товар", "товара", "товаров"));

    } else {
        $cart.hide();
        // $cart.find(".js-cart_total_count_txt").hide();
        // $cart.find(".js-cart_total_price").hide();
        // $cart.find(".js-cart_title_end").text('нет товаров');
    }
};

//обновлялка инфы на странице корзины
var updateCartPage = function () {
    var totalQtyText = "",
        totalQty = 0,
        totalPrice = 0;

    if (Cart.items.length) {
      $('.js-order-button').show();
      for (var item_id in Cart.items) {
        var cur_sum = Cart.items[item_id].price * Cart.items[item_id].qty;
        totalPrice += cur_sum;
        totalQty += Cart.items[item_id].qty;

        var $cart = $('.js-product[data-id=' + Cart.items[item_id].id + ']');
        $cart.find('.product_card_total_cost').text(Meta.beautyPrice(cur_sum) + ' ₽');
        var price = $cart.find('.card_price .actual_price span');
        if (price.length) {
          price.text(Meta.beautyPrice(Cart.items[item_id].price) + ' ₽');
        } else {
          $cart.find('.card_price .actual_price').text(Meta.beautyPrice(Cart.items[item_id].price) + ' ₽');
        }
        $cart.find('.count_input').val(Cart.items[item_id].qty);
        if ($cart.hasClass('product_card_basket')) {
          var item = getItemInGroupById(Cart.items[item_id].id);
          var productCount = $cart.find('.js-cart_input').val();
          var textDeliveryBlock = $cart.find('.product_card_delivery');
          if (item.count_mayer < productCount) {
            $cart.css('border-color', '#e87400');
            textDeliveryBlock.slideDown();
          } else {
            $cart.css('border-color', '#231f20');
            textDeliveryBlock.slideUp();
          }
        }
      }
    } else {
        $('#js-cart_page_items').text('Корзина пуста');
        $('.js-order-button').hide();
    }

    $(".basket_total_items span").text(totalQty);
    $(".basket_total").text(Meta.beautyPrice(totalPrice) + ' ₽');
};

function getProductModId($product) {
    return parseInt($product.attr('data-id'), 10);
}

function getProductPrice($product) {
    return parseFloat($product.attr('data-price').replace(',', '.'));
}

function getProductQty($product) {
    return parseInt($product.find("input.count_input").val());
}

function getProductId($product) {
    return parseInt($product.attr("data-product-id"), 10);
}

function getProductModVariant($product) {
    return $product.attr('data-variant');
}
function getProductTitle($product) {
    return $product.attr('data-title');
}
function getProductCategory($product) {
    return $product.attr('data-category');
}
function getProductBrand($product) {
    return $product.attr('data-brand');
}

function activateCardUi($html) {
    //кнопка купить
    $('.js-product', $html).on("click", ".js-cart_buy", function (e) {
        e.preventDefault();

        var $product = $(e.delegateTarget),
            $this = $(this),
            id = getProductModId($product),
            price = getProductPrice($product),
            qty = getProductQty($product),
            product_id = getProductId($product),
            title = getProductTitle($product),
            variant = getProductModVariant($product),
            category = getProductCategory($product),
            brand = getProductBrand($product)
        ;

        if (isNaN(id) || id === undefined) {
            var form = $product.find('form'),
                volume_text = form.attr('data-volume-text'),
                flavor_text = form.attr('data-flavor-text');
            $product.find('.js-card-alert').html('Выберите ' + flavor_text + '<br> Выберите ' + volume_text).slideDown();
            return;
        } else {
            var item = getItemInGroupById(id);
            if (!item) {
                return;
            }
            if (!item.in_stock) {
                $product.find('.js-card-alert').text('Товара нет в наличии').slideDown();
                return;
            }
            var cart_item = Cart.getItemById(id);
            if (cart_item) {
                cart_item = cart_item.qty + qty;
            } else {
                cart_item = qty;
            }
            if (item.total_count < cart_item) {
                if (item.total_count > 0) {
                    $product.find('.js-card-alert').text('В наличии только ' + item.total_count + ' шт.').slideDown();
                } else {
                    $product.find('.js-card-alert').text('Товара нет в наличии').slideDown();
                }
                return;
            }
            $product.find('.js-card-alert').slideUp();
            $product.find('.js-card-alert').slideUp();
        }

        Cart.putItem({
            id: id,
            price: price,
            qty: qty,
            product_id: product_id
        }, false, function () {

            if (typeof (sendDatalayer) !== 'undefined') {
                if (typeof (getItemForDatalayer) !== 'undefined') {
                    const dataDL = {
                        id: id,
                        price: price,
                        brand: brand,
                        category: category,
                        variant: variant,
                        title: title
                    };
                    const itemDatalayer = getItemForDatalayer(dataDL, qty);
                    sendDatalayer('add_to_cart', [itemDatalayer]);
                }
            }

            updateCartBlock();
            $product.find('.btn_buy').addClass('btn_buy--more').text('+ Еще');
            $('.product_card_active')
                .removeClass("product_card_active")
                .find(".product_card_options")
                .slideUp(250);

            if ($this.hasClass('js-to-cart')) {
                $this
                    .text('Перейти в корзину')
                    .on('click', function (e) {
                        e.preventDefault();
                        window.location.href = '/order/';

                        return false;
                    });
            }
        });

        e.preventDefault();
    });

    // $("a.js-bonus_cart").on("click", function (e) {
    //
    //     var $this = $(this);
    //
    //     Cart.bonuscart(function (response) {
    //         if (response) {
    //             $this.text("Карта в вашей корзине");
    //         } else {
    //             $this.text("Купить карту за 50 ₽");
    //         }
    //     });
    //
    //     e.preventDefault();
    // });

    // ************ страница корзины ***************

    // Удаление товара
    var $page_items = $($html);
    $page_items.on("click", ".js-cart_remove", function (e) {

        var $htmlObj = $(this).closest(".js-product"),
            product_id = parseInt($htmlObj.attr("data-product-id"), 10),
            id = parseInt($htmlObj.attr("data-id"), 10);

        Cart.removeItem({id: id, product_id: product_id}, function () {
            if (typeof (sendDatalayer) !== 'undefined') {
                if (typeof (getItemForDatalayer) !== 'undefined') {
                    const dataDL = {
                        id: id
                    };
                    const itemDatalayer = getItemForDatalayer(dataDL);
                    sendDatalayer('remove_from_cart', [itemDatalayer]);
                }
            }
            $htmlObj.slideUp(500, function () {
                updateCartBlock();
                updateCartPage();
            });
        });

        e.preventDefault();
    });


    //кнопка плюс
    $page_items.on("click", ".js-cart_plus, .js-plus-no-card", function (e) {
        var $product = $(this).parents(".js-product"),
            inputVal = ($product.find(".count_input").val().replace(/\,/, '.') * 1),
            id = getProductModId($product),
            price = getProductPrice($product),
            product_id = getProductId($product),
            newValue;

        if (!inputVal) {
            newValue = 1;
        } else {
            // newValue = (inputVal + 1).toFixed(1) * 1;
            // инкремент в common.js
            newValue = inputVal;
        }

        if (newValue > Cart.maxItemQty) {
            newValue = Cart.maxItemQty;
        }

        var item = getItemInGroupById(id);
        if (item) {
            if (item.total_count <= inputVal) {
                if (item.total_count > 0) {
                    $product.find('.js-card-alert').text('В наличии только ' + item.total_count + ' шт.').slideDown();
                } else {
                    $product.find('.js-card-alert').text('Товара нет в наличии').slideDown();
                }
                newValue = item.total_count || 1;
            } else {
                $product.find('.js-card-alert').slideUp();
            }
        } else {
            $product.find('.js-card-alert').text('Выберите модификацию товара').slideDown();
            newValue = 1;
        }

        $product.find(".count_input").val(newValue);

        if (!$(this).hasClass('js-plus-no-card')) {
            Cart.putItem({
                id: id,
                qty: newValue,
                price: price,
                product_id: product_id
            }, true);

            updateCartBlock();
            updateCartPage();
        }

        e.preventDefault();
    });


    //кнопка минус
    $page_items.on("click", ".js-cart_minus, .js-minus-no-card", function (e) {
        var $product = $(this).parents(".js-product"),
            inputVal = ($product.find(".count_input").val().replace(/\,/, '.') * 1),
            id = getProductModId($product),
            price = getProductPrice($product),
            product_id = getProductId($product),
            newValue;

        if (!inputVal || inputVal === 1) {
            newValue = 1;
        } else {
            // newValue = (inputVal - 1).toFixed(1) * 1;
            // дикремент в common.js
            newValue = inputVal;
        }

        $product.find(".count_input").val(newValue);
        $product.find('.js-card-alert').slideUp();

        if (!$(this).hasClass('js-minus-no-card')) {
            Cart.putItem({
                id: id,
                qty: newValue,
                price: price,
                product_id: product_id
            }, true);

            updateCartBlock();
            updateCartPage();
        }

        e.preventDefault();
    });


    //страница корзины
    //инпут с количеством
    $page_items.on("input", ".js-cart_input, .js-count-no-card", function (e) {
        var $product = $(this).closest(".js-product"),
            id = getProductModId($product),
            price = getProductPrice($product),
            product_id = getProductId($product),
            newQty = parseInt($(this).val(), 10);

        if (!newQty || (newQty <= 0)) {
            newQty = 1;
        }

        if (newQty > Cart.maxItemQty) {
            newQty = Cart.maxItemQty;
        }

        var item = getItemInGroupById(id);
        if (item && item.total_count >= 0) {
            if (item.total_count < this.value) {
                newQty = item.total_count;
                if (item.total_count > 0) {
                    $product.find('.js-card-alert').text('В наличии только ' + item.total_count + ' шт.').slideDown();
                } else {
                    $product.find('.js-card-alert').text('Товара нет в наличии').slideDown();
                    newQty = 1;
                }
                $(this).val(newQty);
                return;
            } else {
                $product.find('.js-card-alert').slideUp();
            }
        } else {
            $product.find('.js-card-alert').text('Выберите модификацию товара').slideDown();
            newQty = 1;
        }

        $(this).val(newQty);

        if (!$(this).hasClass('js-count-no-card') && item && id) {
            Cart.putItem({
                id: id,
                qty: newQty,
                price: price,
                product_id: product_id
            }, true);

            updateCartBlock();
            updateCartPage();

        }
        e.preventDefault();
    });


    $('.js-clear-cart').on('click', function (e) {
        e.preventDefault();

        Cart.removeAll(function () {
            $('#js-cart_page_items').find('.js-product').map(function (i, item) {
                $(item).slideUp(500);
            });
            setTimeout(function () {
                updateCartBlock();
                updateCartPage();
            }, 500);
        });
    });

}

Cart.onInitCallback = function () {
    updateCartBlock();
    updateCartPage();
    $('.js-product').map(function (i, item) {
        if (Cart.items_ids.indexOf(parseInt(item.dataset.productId)) >= 0) {
            $(item).find('.btn_buy').addClass('btn_buy--more').text('+ Еще');
        }
    });
};

Cart.init();

